<template>
  <div class="org-dialog">
    <div class="content">
      <!-- <div class="top">
        <el-button-group>
          <el-button type="primary" icon="el-icon-edit">组织</el-button>
          <el-button type="primary" icon="el-icon-edit">分组</el-button>
          <el-button type="primary" icon="el-icon-edit">角色</el-button>
        </el-button-group>
        <el-checkbox-group v-model="checkList">
          <el-checkbox label="级联选择" />
          <el-checkbox label="显示虚拟组织" />
          <el-checkbox label="显示岗位" />
        </el-checkbox-group>
      </div> -->
      <div class="middle">
        <div class="box">
          <!-- <div class="search">
            <el-input v-model="filterText" placeholder="输入关键字进行过滤" />
            <el-button-group>
              <el-button type="primary" icon="el-icon-edit" />
              <el-button type="primary" icon="el-icon-edit" />
            </el-button-group>
          </div> -->
          <!-- <el-tree ref="tree" class="filter-tree" show-checkbox :data="data" :props="defaultProps" default-expand-all :filter-node-method="filterNode" @check-change="handleCheckChange" @check="check" /> -->
          <el-tree
            ref="tree"
            class="filter-tree"
            show-checkbox
            :props="defaultProps"
            :load="loadTreeNode"
            lazy
            @node-click="handleNodeClick"
            @check-change="handleCheckChange"
            @check="handleNodeCheck"
          />
        </div>
        <div class="box">
          <el-checkbox-group v-model="checkboxEmployee" size="small">
            <template v-if="checkboxEmployee.length > 0">
              <el-checkbox
                v-for="(item, index) in checkboxEmployee"
                :key="index"
                :label="item.name"
                border
              />
            </template>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="close">保存</el-button>
      <el-button @click="close">取 消</el-button>
    </div> -->
  </div>
</template>
<script>
import { apiQueryOrg } from '@/api/common'
export default {
  data() {
    return {
      checkList: [],
      checkboxEmployee: [],
      checkedboxEmployee: {},
      filterText: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      rootNode: [],
      params: {
        parentId: 'orgRoot'
        // code: '',
        // name: '',
        // showVirtualOrg: 0,
        // showPosition: 0,
        // showAllChildrenOrg: 1
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  mounted() {},
  methods: {
    check(data, info) {
      console.log(data, info)
      this.checkboxEmployee = [...this.checkboxEmployee, data]
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log('handleCheckChange', data, checked, indeterminate)
    },
    handleNodeCheck(data, node) {
      console.log('handleNodeCheck', data, node)
      this.checkedboxEmployee = data
      this.checkboxEmployee = [...this.checkboxEmployee, data]
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    handleNodeClick(node) {
      console.log('handleNodeClick', node)
    },
    async queryOrgs(node = { level: 0 }) {
      if (node.level === 0) {
        this.params.parentId = 'orgRoot'
      } else {
        this.params.parentId = node.data.id
      }
      const res = await apiQueryOrg(this.params)
      // const res = await request({
      //   url: '/huigou/org/queryOrgs?parentId=50000000&code&name&showVirtualOrg=0&showPosition=0&showAllChildrenOrg=1',
      //   method: 'post'
      // })
      if (res?.status === 0 && res.data.Total > 0) {
        if (node.level === 0) {
          this.rootNode = res.data.Rows.filter(item => {
            return item.parentId === 'orgRoot' && item.orgCode === 'WLY'
          })
        } else {
          this.rootNode = res.data.Rows
        }
        return Promise.resolve(this.rootNode)
      }
    },
    close() {
      this.$router.back()
    },
    async loadTreeNode(node, resolve) {
      console.log('loadTreeNode-----', node)
      const data = await this.queryOrgs(node)
      // if(node.level >0){
      //   this.rootNode = da
      // }
      if (data) {
        data.map(item => {
          if (item.hasChildren === 0) {
            item.leaf = false
          }
        })
        console.log('data', data)
        resolve(data)
      } else {
        resolve([])
      }
    },
    // 用于弹窗提交时 回调数据
    submitForm() {
      // 给父组件返回promise对象用于回调
      return new Promise(resolve => {
        // this.$refs['productForm'].validate(async valid => {
        Object.keys(this.checkedboxEmployee).length && (
          this.checkedboxEmployee.code = this.checkedboxEmployee.deptCode
        )
        resolve(this.checkedboxEmployee)
        // 表单验证情况
        // if (!valid) return false
        // 参数
        // const params = {}
        // this.loading = true
        // 提交接口请求
        // apiUpdateUserInfo(params)
        //   .then(() => {
        //     this.loading = false
        //     this.$message.success('更新成功')
        //     resolve(true)
        //   })
        //   .catch(() => {
        //     this.loading = false
        //     resolve(false)
        //   })
        // })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.org-dialog {
  height: 100%;
  background: #fff;
  overflow: hidden;
  .content {
    padding: 20px 10px;
    .top {
      display: flex;
      align-items: center;
      .el-button-group {
        margin-right: 10px;
      }
    }
    .middle {
      margin-top: 10px;
      display: flex;
      overflow: hidden;
      .box {
        flex: 1;
        border: 1px solid rgba(204, 204, 204, 0.658);
        padding: 0px 6px;
        height: 300px;
        overflow: hidden;
        .filter-tree {
          height: 100%;
          overflow: scroll;
        }
        .el-checkbox-group {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          .el-checkbox {
            margin-right: 10px;
            .el-checkbox__input {
              visibility: hidden;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/OrgSelect.vue